import * as zod from 'zod';

export const validateFormSearchSchema = (min = 2) => {
  const formSearchSchema = zod.object({
    searchTerm: zod
      .string({ required_error: 'Campo obrigatório' })
      .min(min, `Campo deve ter no mínimo ${min} caracteres`)
      .refine((value) => value.trim() !== '', {
        message: 'Campo não pode consistir apenas de espaços em branco',
      }),
  });

  return formSearchSchema;
};

export type SearchFormData = zod.infer<ReturnType<typeof validateFormSearchSchema>>;

export const minValueSearchSchema = { equity: 5 };
